import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const BannerContainer = styled.div`
  background-color: ${colors.feedback.warningLight};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 16px 16px 16px;
`

export const UpdatePrioritiesLink = styled.div`
  right: 16px;
  font-size: 13px;
  ${typography.down2.semiBoldSans};
`

export const BannerHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  width: auto;
  margin-right: 5px;
`

export const BannerHeader = styled.h3`
  ${typography.down2.semiBoldSans};
  color: ${colors.copy.paragraphDark};
  margin: 8px 0px;
  font-size: 16px;
`

export const BannerText = styled.div`
  color: ${colors.copy.paragraphDark};
  ${typography.baseline.regularSans};
  font-size: 14px;
  margin-left: 32px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`

export const ButtonText = styled.span`
  ${typography.baseline.semiBoldSans};
`
